/* eslint-disable no-underscore-dangle */
import { createAction } from '@reduxjs/toolkit';
import type { BillsState } from '../reducers/bills';
import type { AppThunk } from '../store/configureStore';
import { throwOnError } from './utils';

export const GET_BILLS = createAction<BillsState>('GET_BILLS');

type FetchBillResponse = {
  id: string;
  amount: number | null;
  max_amount: number | null;
  min_amount: number | null;
  description: string | null;
  is_onetime: boolean;
  is_disabled: boolean;
  token: string;
  private_money: {
    name: string;
  };
  user: {
    id: string;
    name: string;
  };
  additional_private_moneys?: {
    id: string;
    name: string;
  }[];
};

type FetchBillsResponse = {
  count: number;
  rows: {
    id: string;
    amount: number | null;
    created_at: string;
    description: string | null;
    is_disabled: boolean;
    shop_name: string;
    org_name: string;
    token: string;
  }[];
};

export const getBills =
  (params: string): AppThunk =>
  (dispatch) =>
    fetch(`/api/bills?${params}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
    })
      .then<BillsState>(throwOnError)
      .then((bills) => dispatch(GET_BILLS(bills)));

export const updateBill =
  (uuid: string, params: Record<string, unknown> = {}) =>
  () =>
    fetch(`/api/bills/${uuid}`, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...params }),
    })
      .then((response) => response.json())
      .then((bill) => {
        return new Promise((resolve, reject) => {
          if (bill.type === 'api_error') {
            reject();
          } else {
            resolve(bill);
          }
        });
      });

// Fetchers

export const createBill = (postData: Record<string, unknown> = {}) =>
  fetch('/api/bills', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
  }).then(throwOnError<FetchBillResponse>);

export const fetchBills = (query = '') =>
  fetch(`/api/bills?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<FetchBillsResponse>);

export const fetchBill = (uuid: string) =>
  fetch(`/api/bills/${uuid}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
  }).then(throwOnError<FetchBillResponse>);

export const updateBills = (uuid: string, params: Record<string, unknown> = {}) =>
  fetch(`/api/bills/${uuid}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ ...params, _csrf_token: (window as any)._csrf_token }),
  }).then(throwOnError);
